"use client";

import {
  FaHamburger,
  FaGraduationCap,
  FaCamera,
  FaSpa,
  FaHeartbeat,
  FaPaw,
} from "react-icons/fa";

import Link from "next/link";
import { featuredCarouselTranslations } from "@/lib/servicesTranslations";
import { JSX } from "react";
import { useParams } from "next/navigation";

// 1. Define the union of all valid labels
type ServiceLabel =
  | "Food"
  | "Health & Wellness"
  | "Pet Sitting"
  | "Tutoring"
  | "Beauty"
  | "Photography";

export default function FeaturedCarousel() {
  const params = useParams();
  const locale = (params?.locale as "pt" | "en") ?? "pt";
  const t = featuredCarouselTranslations[locale] ?? featuredCarouselTranslations["pt"];

  const services: {
    slug: string;
    label: ServiceLabel;
    color: string;
    icon: JSX.Element;
  }[] = [
    {
      slug: "food",
      label: "Food",
      color: "#F4A261",
      icon: <FaHamburger size={26} className="text-white h-5 lg:h-7" />,
    },
    {
      slug: "health-wellness",
      label: "Health & Wellness",
      color: "#2A9D8F",
      icon: <FaHeartbeat size={26} className="text-white h-5 lg:h-7" />,
    },
    {
      slug: "pet-sitting",
      label: "Pet Sitting",
      color: "#E9C46A",
      icon: <FaPaw size={26} className="text-white h-5 lg:h-7" />,
    },
    {
      slug: "tutoring",
      label: "Tutoring",
      color: "#457B9D",
      icon: <FaGraduationCap size={26} className="text-white h-5 lg:h-7" />,
    },
    {
      slug: "beauty",
      label: "Beauty",
      color: "#C471ED",
      icon: <FaSpa size={26} className="text-white h-5 lg:h-7" />,
    },
    {
      slug: "photography",
      label: "Photography",
      color: "#264653",
      icon: <FaCamera size={26} className="text-white h-5 lg:h-7" />,
    },
  ];

  return (
    <section className="py-4 mb-5 pb-8">
      <h2 className="text-xl text-[#1B475D] font-bold mb-6">{t.heading}</h2>
      <div className="carousel-scroll flex gap-4 overflow-x-auto py-2">
        {services.map((item) => (
          <Link
            key={item.slug}
            href={`/${locale}/services/${item.slug}`}
            className="min-w-[140px] md:min-w-[235px] flex-shrink-0 bg-white rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition cursor-pointer hover:border-[#8EBD9D]"
          >
            <div className="flex flex-col items-center px-4 py-6 gap-4">
              <div
                className="w-15 h-15 md:w-20 md:h-20 rounded-full shadow flex items-center justify-center"
                style={{ backgroundColor: item.color }}
              >
                <div className="text-3xl text-[#1B475D]">{item.icon}</div>
              </div>
              <p className="text-center font-semibold text-[#1B475D] text-sm md:text-base">
                {t.labels[item.label]}
              </p>
              <button className="w-full bg-[#8ebd9d] hover:bg-[#77A885] text-[#1B475D] text-sm font-semibold py-2 px-4 rounded transition">
                {t.explore}
              </button>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
